import gl from "../data/1500.json";
import ul from "../data/2500.json";

class FilterData {
    getGreatLeague = (rank, att, def, hp, lv) => {
        const result = [];
        for (let poke of gl) {
            for (let stat of poke.stat) {
                if (Number(stat.rank) <= Number(rank) && stat.att === att && stat.def === def && stat.hp === hp && Number(stat.lv) <= Number(lv)) {
                    result.push({
                        name: poke.name,
                        ...stat
                    })
                }
            }
        }
        return result;
    };

    getUltraLeague = (rank, att, def, hp, lv) => {
        const result = [];
        for (let poke of ul) {
            for (let stat of poke.stat) {
                if (Number(stat.rank) <= Number(rank) && stat.att === att && stat.def === def && stat.hp === hp && Number(stat.lv) <= Number(lv)) {
                    result.push({
                        name: poke.name,
                        ...stat
                    })
                }
            }
        }
        return result;
    };
}

export default new FilterData();
